import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22.009 11a3 3 0 0 0-3-3h-4.342a4 4 0 0 0-3.976 3.563A115 115 0 0 0 10 24.07q-.005 6.23.67 12.367A4 4 0 0 0 14.645 40h4.363a3 3 0 0 0 3-3zm-9.33.782A113 113 0 0 0 12 24.07q-.005 6.12.658 12.147A2 2 0 0 0 14.646 38h4.363a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-4.342a2 2 0 0 0-1.988 1.782m25.33 12.288a115 115 0 0 0-.691-12.507A4 4 0 0 0 33.342 8H29a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h4.363a4 4 0 0 0 3.977-3.563q.673-6.136.669-12.367M28 11a1 1 0 0 1 1-1h4.342a2 2 0 0 1 1.988 1.782q.675 6.144.679 12.289.004 6.12-.658 12.147A2 2 0 0 1 33.363 38H29a1 1 0 0 1-1-1z",
      clipRule: "evenodd"
    }
  )
);
var SvgPauseOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PauseOutlined_default = SvgPauseOutlined;

export { PauseOutlined_default as default };
